module.exports = __webpack_public_path__ + "static/rainbow-only-desktop-b198a2cfd2c380f8c884e5f5a0bfbaca.png";